import { lazy, Suspense } from "react";

import { PageLoadingFallback } from "@/components/layout/PageLoadingFallback";

/**
 * Main App Component
 * Conditionally loads LocalScreenManager or TenantScreenManager based on the
 * Vite build mode (`import.meta.env.DEV`). Uses React.lazy() for optimal code
 * splitting and tree-shaking.
 *
 * Note: DEV here is Vite's dev-vs-build flag, NOT the DEV/QA/PROD tenant
 * stages. The tenant-deployed bundle (TenantScreenManager) is the same on all
 * tenant stages; only the local Vite dev server uses LocalScreenManager.
 */

// Conditionally lazy-load the appropriate screen manager
const ScreenManager = lazy(() => {
  if (import.meta.env.DEV) {
    return import("./LocalScreenManager");
  } else {
    return import("./TenantScreenManager");
  }
});

export default function App() {
  return (
    <Suspense fallback={<PageLoadingFallback />}>
      <ScreenManager />
    </Suspense>
  );
}
